module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_BlackMatted_MockedUp.63562b23.jpg";